import { render, staticRenderFns } from "./ProductView.vue?vue&type=template&id=570cf38e&scoped=true"
import script from "./ProductView.vue?vue&type=script&lang=ts"
export * from "./ProductView.vue?vue&type=script&lang=ts"
import style0 from "./ProductView.vue?vue&type=style&index=0&id=570cf38e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "570cf38e",
  null
  
)

export default component.exports